import { useContext } from 'react';
import ModalProvider from '@/contexts/modal-provider';

const useModalState = () => {
  const value = useContext(ModalProvider);

  return value;
};
    
export default useModalState;